module.exports = __webpack_public_path__ + "static/natural-194ffa0f77fcfc5a17dc5cd905bf00c1.png";